module.exports = __webpack_public_path__ + "static/media/07_motor-driver-module.5c93b191.mp4";